module.exports = __webpack_public_path__ + "images/_/assets/images/ajax-loader.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ajax-loader.gif
// module id = ./src/assets/images/ajax-loader.gif
// module chunks = 1